// src/components/ReportsPricing.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import "./ReportsPricing.css";

const ReportsPricing = function () {
  const navigate = useNavigate();
  const go = (path) => () => navigate(path);

  const button = (label, onClick, props = {}) =>
    React.createElement("button", { onClick, ...props }, label);

  return React.createElement(
    Layout,
    null,
    React.createElement(
      "div",
      { className: "reports-pricing-container" },

      // Title
      React.createElement("h1", null, "Download GeM Procurement Reports (Direct Orders and Bids)"),

      // Intro
      React.createElement(
        "p",
        null,
        "Explore what government departments and state agencies are buying on GeM. ",
        "Our ready-to-use Excel reports aggregate contract-level data and summarize trends so you can quickly see ",
        React.createElement("b", null, "which categories are most active"),
        ", ",
        React.createElement("b", null, "who’s buying"),
        ", and ",
        React.createElement("b", null, "how value moves over time"),
        ". Choose a report type below, pick your entity, view the ",
        React.createElement("b", null, "available date range"),
        ", get an ",
        React.createElement("b", null, "instant price"),
        " (based on rows), pay securely, and download immediately."
      ),

      // Buttons (now prominent + mobile-friendly)
      React.createElement("h3", null, "Buy/Get a Report"),
      React.createElement(
        "div",
        { className: "reports-buttons" },
        button("Buy/Get Product Reports", go("/product-reports")),
        button("Buy/Get Service Reports", go("/service-reports")),
        button("Buy/Get Central Ministry Reports", go("/ministry-reports")),
        button("Buy/Get State Reports", go("/state-reports"))
      ),

      // Inside ReportsPricing component render, near top or under intro

      React.createElement(
        "div",
        { className: "reports-subscription-banner" },
        React.createElement("h3", null, "Prefer an annual plan?"),
        React.createElement(
          "p",
          null,
          "Get full Reports access for any Category, Ministry, Department, State plus Tender Tracker (Discovery and Results) access starting at ₹5,999/annum."
        ),
        button("Subscribe to Annual Plan", go("/reports-combo-subscription"))
      ),

      // Samples (updated)
React.createElement("h3", null, "Sample Reports"),
React.createElement(
  "ul",
  { className: "sample-reports-list" },

  React.createElement(
    "li",
    null,
    React.createElement(
      "a",
      {
        href: "/sample_reports/product_panel-air-conditioner__2024-10-03_2025-03-29.xlsx",
        download: "product_panel-air-conditioner__2024-10-03_2025-03-29.xlsx",
      },
      "📄 Product: Panel Air Conditioner (2024-10-03 → 2025-03-29)"
    )
  ),

  React.createElement(
    "li",
    null,
    React.createElement(
      "a",
      {
        href: "/sample_reports/service__annual-maintenance-service-data-center-assets__2025-01-30_2025-01-31.xlsx",
        download: "service__annual-maintenance-service-data-center-assets__2025-01-30_2025-01-31.xlsx",
      },
      "📄 Service: Annual Maintenance (Data Center Assets) (2025-01-30 → 2025-01-31)"
    )
  ),

  React.createElement(
    "li",
    null,
    React.createElement(
      "a",
      {
        href: "/sample_reports/ministry_department__department-of-earth-sciences__2024-01-22_2025-01-29.xlsx",
        download: "ministry_department__department-of-earth-sciences__2024-01-22_2025-01-29.xlsx",
      },
      "📄 Ministry (Department): Dept. of Earth Sciences (2024-01-22 → 2025-01-29)"
    )
  ),

  React.createElement(
    "li",
    null,
    React.createElement(
      "a",
      {
        href: "/sample_reports/state__organisation_uttarakhand_uttarakhand-open-university-nainital__2023-08-30_2024-12-21.xlsx",
        download: "state__organisation_uttarakhand_uttarakhand-open-university-nainital__2023-08-30_2024-12-21.xlsx",
      },
      "📄 State (Organisation): Uttarakhand Open University, Nainital (2023-08-30 → 2024-12-21)"
    )
  )
),


      // Note
      React.createElement(
        "p",
        { className: "reports-note" },
        "Prices are computed dynamically from the selected date range and rows matched. ",
        "You’ll see the exact amount before paying."
      )
    )
  );
};

export default ReportsPricing;
